import { render, staticRenderFns } from "./ItemNotificationComponent.vue?vue&type=template&id=0bfae4e5&scoped=true"
import script from "./ItemNotificationComponent.vue?vue&type=script&lang=js"
export * from "./ItemNotificationComponent.vue?vue&type=script&lang=js"
import style0 from "./ItemNotificationComponent.vue?vue&type=style&index=0&id=0bfae4e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfae4e5",
  null
  
)

export default component.exports